export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8684.0b0a526e.jpg";